import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IRedirectToStoreStore} from './store.stores';
import {TsRedirectToStore} from './TsRedirectToStore';
import {DashboardLayout} from '../views/layout/DashboardLayout';

import '../views/DashboardNewView.scss';

interface StoreViewProps {
    redirectToStoreStore: IRedirectToStoreStore;
}

@observer
export class StoreViewComponent extends TechseeBaseComponent<StoreViewProps> {
    renderInternal(): JSX.Element {
        const {redirectToStoreStore} = this.props;
        const controller = redirectToStoreStore?.redirectToStoreController;

        if (!controller) {
            return <React.Fragment />;
        }

        return (
            <div className='dashboard-container ts-horizontal-layout bright-dashboard'>
                <DashboardLayout>
                    <TsRedirectToStore controller={controller} />
                </DashboardLayout>
            </div>
        );
    }
}

export const StoreView = inject('redirectToStoreStore')(StoreViewComponent) as IReactComponent;
